import React from 'react';
import {HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP} from './Hero.elements';
import Video from '../../images/video1.mp4';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function Herosection() {
    const matches = useMediaQuery('(max-width:768px)');
    return (
        <>
            <HeroContainer>
                <HeroBg>
                    {matches?null:<VideoBg  autoPlay muted loop src={Video} type='video/mp4'/>}
                </HeroBg>
                <HeroContent>
                    <HeroH1>
                            IDentrix Protocol
                    </HeroH1>
                    <HeroP>
                            Your Identity key to access the Future of Decentralised World
                    </HeroP>
                </HeroContent>
            </HeroContainer>
        </>
    );
}

export default Herosection;
